import { Padding, Size, Style, TextAlignment } from '../Section';
import { EMPTY_WIDTH } from '../utils';

import styles from './TabContent.module.scss';

const Column = ({ unsavedData, updateData }: TabContentProps) => {
  const handleUpdateData: SectionProps['updateData'] = (updateDataProps) => {
    updateData({ element: 'COLUMN', ...updateDataProps });
  };

  return (
    <div className={styles.root}>
      <div className={styles.column}>
        <Size width={unsavedData?.width ?? EMPTY_WIDTH} updateData={handleUpdateData} />
        <Padding padding={unsavedData?.padding} updateData={handleUpdateData} />
      </div>
      <div className={styles.column}>
        <TextAlignment
          textAlignment={unsavedData?.textAlignment}
          verticalAlignment={unsavedData?.verticalAlignment}
          updateData={handleUpdateData}
        />
        <Style
          background={unsavedData?.background}
          border={unsavedData?.border}
          updateData={handleUpdateData}
        />
      </div>
    </div>
  );
};

export default Column;
